<template>
  <div class="model_new_position">
    <div class="model_new_position__header">
      <h4 class="title">
        {{ primary_data.id ? translate("specification.position.update_title") : translate("specification.position.new_title") }}
      </h4>
    </div>

    <div class="model_new_position__body">
      <div class="new_position">
        <div class="block">
          <div class="row">
            <div class="col-md-6 col-sm-6 input_wrap">
              <label>
                {{ translate('specification.position.device_sku') }}
              </label>
              <tree-select
                  :options="device_sku_list"
                  :placeholder="translate('specification.position.device_sku')"
                  v-model="primary_data.device_sku_id"
                  :clearable="false"
                  :multiple="false"
                  :disabled="primary_data.id && primary_data.id > 0"
              />
            </div>

            <div class="col-md-6 col-sm-6 input_wrap">
              <fg-input
                  v-model="primary_data.qty_required"
                  type="number"
                  :max="300"
                  :label="translate('specification.position.qty')"
                  :placeholder="translate('specification.position.qty')"
                  :clearable="true"
                  @input="check_qty"
              />
            </div>
          </div>

          <div class="row">
            <div class="col-md-6 col-sm-6 input_wrap">
              <WrapDatePicker
                  type="date"
                  value_type="YYYY-MM-DD"
                  v-model="primary_data.planned_finish_date"
                  :range="false"
                  :confirm="false"
                  :disabled_date="['- 1 month', '+ 12 month']"
                  :placeholder="translate('specification.position.planned_date')"
                  :label="translate('specification.position.planned_date')"
              />
            </div>
          </div>

          <div class="row">
            <div class="col-md-12 col-sm-12 text_wrap">
              <div class="form-group">
                <label>{{ translate('specification.position.equipment') }}</label>
                <textarea class="input_text" name="equipment" v-model="primary_data.equipment" rows="3" />
              </div>
            </div>
          </div>

          <div class="row">
            <div class="col-md-12 col-sm-12 text_wrap">
              <div class="form-group">
                <label>{{ translate('specification.position.description') }}</label>
                <textarea class="input_text" name="equipment" v-model="primary_data.descr" rows="3" />
              </div>
            </div>
          </div>
        </div>
      </div>
    </div>
    <div class="model_new_position__footer">
      <span
          class="btn btn-success btn-fill btn-wd"
          @click.prevent="edit_new_position"
      >
        {{ primary_data.id ? translate('btn.edit') : translate('btn.add') }}
      </span>
      <span
        class="btn btn-danger btn-fill btn-wd"
        @click.prevent="close_modal"
      >
        {{ translate('cancel') }}
      </span>
    </div>

  </div>
</template>
<script>

import WrapDatePicker from "components/UIComponents/WrapDatePicker/WrapDatePicker.vue";

export default {
  name: 'EditPositionModal',
  props:{
    specification_id: {
      type: [Number],
      required: true
    },
    position: {
      type: [Object],
      required: true
    },
  },
  components: {
    WrapDatePicker
  },
  data () {
    return {
      primary_data: {
        device_sku_id: null,
        qty_required: null,
        planned_finish_date: null,
        equipment: "",
        descr: ""
      },
    }
  },
  computed:{
    device_sku_list(){
      return this.$store.getters.getDeviceSkus.map((sku) => {
        return {label: sku.name, id: sku.id}
      })
    },
  },

  created() {
    this.primary_data = Object.assign({}, this.position)
  },

  methods: {
    check_qty(){
      if(Number(this.primary_data.qty_required) >= 300) this.primary_data.qty_required = 300
    },
    edit_new_position(){
      this.primary_data.qty_required = Number(this.primary_data.qty_required)

      if (this.primary_data.id){
        this.$http.v1.updatePositionInSpecification(this.primary_data.id, this.primary_data, (response) => {
          this.global_notify('info', this.translate('specification.saved_success'))
          this.update()
          this.close_modal()
        })
      } else {
        this.$http.v1.createNewPositionInSpecification(this.specification_id, this.primary_data, (response) => {
          this.global_notify('info', this.translate('specification.saved_success'))
          this.update()
          this.close_modal()
        })
      }
    },
    update(){
      this.$emit('update')
    },
    close_modal () {
      this.$emit('close')
    }
  }
}

</script>

<style lang='scss' scoped>
.model_new_position{
  height: 100%;
  padding: 10px;
  &__header{
    display: flex;
    align-items: center;
    padding-bottom: 10px;
    .title{
      width: 100%;
      margin: 0;
      text-align: center;
    }
    .links{
      width: 30%;
      & > .vue-treeselect{
        margin-bottom: 0;
      }
    }
  }
  &__body{
    width: 100%;
    .new_position{
      width: 100%;
      height: 100%;
      .block{
        padding: 10px;
        .row{
          margin-bottom: 10px;
        }
        .input_wrap,
        .text_wrap{
          text-align: start;
        }
        .form-group{
          margin-bottom: 0;
        }
      }
    }

  }
  &__footer{
    display: flex;
    justify-content: center;
    align-items: center;
    padding-top: 10px;
    .btn{
      margin: 0 10px 0 0;
      &:last-child{
        margin-right: 0;
      }
    }
  }
}

</style>
